enum PopupActionType {
    Outside = "outside",
    Confirm = "confirm",
    Cancel = "cancel"
}

export default PopupActionType;